import React, { useState } from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { GetApp, PlayArrow } from "@material-ui/icons";

const formatDuration = (seconds) => {
  if (!Number.isFinite(seconds) || seconds <= 0) return "";
  const total = Math.round(seconds);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s < 10 ? "0" : ""}${s}`;
};

// Vídeo da conversa com estado próprio. Antes o carregando/erro era um só para a lista
// inteira: um vídeo com defeito marcava todos os outros como "erro ao carregar".
// Com `onOpen`, a bolha mostra só a capa com o botão de tocar e o clique abre o visualizador
// (como no WhatsApp Web); sem ele, toca ali mesmo com os controles do navegador.
const VideoBubble = ({ url, fileName, className, errorClassName, onOpen }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [duration, setDuration] = useState("");

  if (error) {
    return (
      <div className={errorClassName}>
        <Typography variant="body2" style={{ marginBottom: 12 }}>
          Este vídeo não pode ser reproduzido no navegador.
        </Typography>
        <Button
          startIcon={<GetApp />}
          component="a"
          href={url}
          download={fileName || "video.mp4"}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          size="small"
        >
          Baixar vídeo
        </Button>
      </div>
    );
  }

  if (onOpen) {
    return (
      <div
        style={{ maxWidth: 400, width: "100%", position: "relative", cursor: "pointer", lineHeight: 0 }}
        role="button"
        tabIndex={0}
        aria-label="Abrir vídeo"
        onClick={onOpen}
        onDoubleClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onOpen();
          }
        }}
      >
        <video
          className={className}
          // o fragmento de tempo faz o navegador desenhar o primeiro quadro como capa
          src={`${url}#t=0.1`}
          preload="metadata"
          muted
          playsInline
          style={{ width: "100%", height: "auto", maxHeight: 300, minHeight: 120, objectFit: "cover", opacity: loading ? 0.3 : 1, transition: "opacity 0.3s ease" }}
          onLoadedMetadata={(e) => setDuration(formatDuration(e.currentTarget.duration))}
          onLoadedData={() => setLoading(false)}
          onCanPlay={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 52,
            height: 52,
            margin: "-26px 0 0 -26px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(11,20,26,0.55)",
            color: "#ffffff",
          }}
        >
          {loading ? <CircularProgress size={26} color="inherit" /> : <PlayArrow style={{ fontSize: 32 }} />}
        </span>
        {duration && (
          <span
            style={{
              position: "absolute",
              left: 8,
              bottom: 8,
              padding: "1px 6px",
              borderRadius: 8,
              backgroundColor: "rgba(11,20,26,0.55)",
              color: "#ffffff",
              fontSize: 11.5,
              lineHeight: "16px",
            }}
          >
            {duration}
          </span>
        )}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 400, width: "100%", position: "relative" }}>
      {loading && (
        <CircularProgress
          size={30}
          style={{ position: "absolute", top: "50%", left: "50%", margin: "-15px 0 0 -15px", zIndex: 2 }}
        />
      )}
      <video
        className={className}
        src={url}
        controls
        preload="metadata"
        playsInline
        style={{ width: "100%", height: "auto", maxHeight: 300, opacity: loading ? 0.3 : 1, transition: "opacity 0.3s ease" }}
        onLoadedData={() => setLoading(false)}
        onCanPlay={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
      />
    </div>
  );
};

export default VideoBubble;
